import { APP_INITIALIZER, inject } from '@angular/core';
import { ABP, RoutesService } from '@abp/ng.core';
import { OFERTA_RECORD_BASE_ROUTES } from './oferta-record-base.routes';

export const OFERTA_RECORDS_OFERTA_RECORD_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: configureRoutes,
  },
];

function configureRoutes() {
  const routesService = inject(RoutesService);

  return () => {
    const routes: ABP.Route[] = [...OFERTA_RECORD_BASE_ROUTES];
    // routesService.add(routes);
  };
}
